import React, { useState, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';

// The duration in milliseconds before the indicator hides automatically.
const HIDE_TIMEOUT = 5000; // 5 seconds

const ScrollIndicator = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Set a timer to automatically hide the indicator.
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, HIDE_TIMEOUT);

    const handleScroll = () => {
      // Hide the indicator if the user scrolls down.
      if (window.scrollY > 50) {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    // Cleanup function to run when the component is unmounted.
    return () => {
      // Remove the scroll listener to prevent memory leaks.
      window.removeEventListener('scroll', handleScroll);
      // Clear the timeout to prevent it from running if the component unmounts early.
      clearTimeout(timer);
    };
  }, []); // Empty array ensures this effect runs only once on mount.

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed bottom-5 left-1/2 -translate-x-1/2 z-50 flex justify-center">
      <div className="animate-bounce bg-yellow-400 p-3 rounded-full shadow-lg">
        <ChevronDown className="text-white h-6 w-6" />
      </div>
    </div>
  );
};

export default ScrollIndicator;